export const BENCHMARK_DEFAULT_FILTER = 'IBOVESPA';
export const PERIOD_DEFAULT_FILTER = 'MONTH';
